import { Waypoint as OriginalWaypoint } from 'react-waypoint'
import React from 'react'

const ReactWaypoint = OriginalWaypoint as any

const Waypoint = props => <ReactWaypoint {...props} />

export default Waypoint
